import { render, staticRenderFns } from "./AccidentInitialForm.vue?vue&type=template&id=63497fd6&scoped=true"
import script from "./AccidentInitialForm.vue?vue&type=script&lang=js"
export * from "./AccidentInitialForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentInitialForm.vue?vue&type=style&index=0&id=63497fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63497fd6",
  null
  
)

export default component.exports